export const LOGGER_ENRICHMENT = {
    domain: '@fiverr-private/experiments_package'
};
